module.exports = __webpack_public_path__ + "media/images/smart_phone/item/btn_clap-7f46d8c4cb9ad31740135c3fbd3b0169.png";